import * as actionTypes from './actionTypes';
import axios from '../../axios-orders';

export const addIngredient = (ingredient) => {
	return {
		type: actionTypes.ADD_INGREDIENTS,
		ingredient,
	};
};
export const removeIngredient = (ingredient) => {
	return {
		type: actionTypes.REMOVE_INGREDIENTS,
		ingredient,
	};
};

export const setIngredientsAndPrice = (ingredients, ingPrices) => {
	return {
		type: actionTypes.SET_INGREDIENTS_AND_PRICE,
		ingredients,
		ingPrices,
	};
};

export const fetchIngredientsFailed = (error) => {
	return {
		type: actionTypes.FETCH_INGREDIENTS_FAILED,
	};
};

export const initIngredients = () => {
	return (dispatch, getState) => {
		axios
			.get('ingredients')
			.then((res) => {
				const prices = {};
				const defaultState = {};
				for (let ing in res.data.ingredients) {
					defaultState[ing] = 0;
					prices[ing] = res.data.ingredients[ing].price;
				}
				dispatch(setIngredientsAndPrice(defaultState, prices));
			})
			.catch((e) => {
				dispatch(fetchIngredientsFailed());
			});
	};
};
